import styles from './ConnectionRow.module.css';

function formatJoined(timestamp) {
  if (!timestamp) return '';
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return 'joined ' + date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export default function ConnectionRow({ friend, onViewFeed, onRemove }) {
  return (
    <div className={styles.row} onClick={() => onViewFeed(friend.userId)}>
      {friend.photoURL ? (
        <img src={friend.photoURL} alt={friend.displayName} className={styles.avatar} />
      ) : (
        <div className={styles.avatarFallback}>
          {friend.displayName.charAt(0).toUpperCase()}
        </div>
      )}
      <div className={styles.info}>
        <span className={styles.name}>{friend.displayName}</span>
        <span className={styles.joined}>{formatJoined(friend.addedAt)}</span>
      </div>
      <button
        className={styles.removeBtn}
        onClick={(e) => { e.stopPropagation(); onRemove(friend); }}
      >
        Remove
      </button>
    </div>
  );
}
